import { createAction, props } from '@ngrx/store';
import { MenuItem } from '@service/app-toolbar/app-toolbar.service';

export const loadAllMenuItems = createAction('[Menu Component] Load Menu Items');
export const addMenuItem = createAction('[Menu Component] Add Menu Item', props<{ payload: MenuItem }>());
export const updateMenuItem = createAction('[Menu Component] Update Menu Item', props<{ payload: MenuItem }>());
export const clearMenu = createAction('[Menu Component] Clear Menu');
export const clearAdminUrlsMenu = createAction('[Menu Component] Clear AdminUrls Menu');
export const clearInstitutionUrlsMenu = createAction('[Menu Component] Clear InstitutionUrls Menu');
export const addAdminUrlMenuItem = createAction('[Menu Component] Add AdminUrl Menu Item', props<{ payload: MenuItem }>());
export const addInstitutionUrlMenuItem = createAction('[Menu Component] Add InstitutionUrl Menu Item', props<{ payload: MenuItem }>());
export const setIsSuperUser = createAction('[Menu Component] Set is super user');
export const setIsInstitution = createAction('[Menu Component] Set is institution');
